import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { inject } from "@vercel/analytics";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://e81bec94a11cf4a3fb710fc740710ab1@o4511103279104000.ingest.us.sentry.io/4511103280545792",
  sendDefaultPii: true,
});

inject();
createRoot(document.getElementById("root")!).render(<App />);
